"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListGroup = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _listGroup = require("./listGroup.style");

var _listGroup2 = require("./listGroup.components");

var _Loading = require("../Loading/Loading");

var _convertDigits = require("../../utils/convertDigits");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ListGroup = function ListGroup(_ref) {
  var items = _ref.items,
      selectAll = _ref.selectAll,
      placeholder = _ref.placeholder,
      focus = _ref.focus,
      limit = _ref.limit,
      loading = _ref.loading,
      selected = _ref.selected,
      addItem = _ref.addItem,
      removeItem = _ref.removeItem,
      option = _ref.option,
      addOnChange = _ref.addOnChange,
      removeOnChange = _ref.removeOnChange;
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _listGroup.useStyles)({
    size: "sm",
    flag: true,
    selectAll: selectAll
  });
  var listItemsRef = (0, _react.useRef)();

  function handleSelectItem(type, arr) {
    if (type) addItem(arr);else removeItem(arr);
  }

  function handleOnChange(type, arr) {
    if (type) addOnChange(arr);else removeOnChange(arr);
  }

  function list() {
    return items.map(function (item, itemIndex) {
      return /*#__PURE__*/_react["default"].createElement(_listGroup2.ListGroupComponents, {
        item: item,
        key: itemIndex,
        select: function select(type, arr) {
          return handleSelectItem(type, arr);
        },
        onChange: function onChange(type, arr) {
          return handleOnChange(type, arr);
        },
        limit: limit,
        state: selected,
        option: option
      });
    });
  }

  function filter(v) {
    var _iterator = _createForOfIteratorHelper(listItemsRef.current.children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        var txtContent = value.textContent;

        if (txtContent.indexOf(v) > -1) {
          value.style.display = "";
        } else {
          value.style.display = "none";
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.listGroupBox
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.searchBox
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    onChange: function onChange(e) {
      return filter(e.target.value);
    },
    className: classes.searchBar,
    placeholder: placeholder,
    autoFocus: focus
  }), selectAll && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.selectAll,
    onClick: function onClick() {
      return selectAll();
    }
  }, "\u0647\u0645\u0647"), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.selected
  }, (0, _convertDigits.toPersianDigits)(selected.toLocaleString()), " ", "\u0627\u0632", " ", (0, _convertDigits.toPersianDigits)(limit.toLocaleString()), " ", "\u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647")), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.list,
    ref: listItemsRef
  }, loading ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.empty
  }, /*#__PURE__*/_react["default"].createElement(_Loading.Loading, null)) : items.length ? list() : /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.empty
  }, "\u062F\u0627\u062F\u0647 \u0627\u06CC \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F")));
};

exports.ListGroup = ListGroup;
ListGroup.prototype = {
  items: _propTypes["default"].array,
  multiple: _propTypes["default"].bool,
  selectAll: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  focus: _propTypes["default"].bool,
  limit: _propTypes["default"].number,
  loading: _propTypes["default"].bool,
  selected: _propTypes["default"].number,
  addItem: _propTypes["default"].func,
  removeItem: _propTypes["default"].func,
  option: _propTypes["default"].object,
  addOnChange: _propTypes["default"].func,
  removeOnChange: _propTypes["default"].func
};
ListGroup.defaults = {
  items: [],
  multiple: false,
  placeholder: null,
  focus: false,
  limit: null,
  selected: 0,
  option: {
    input: null,
    dropdown: null
  },
  addOnChange: function addOnChange() {},
  removeOnChange: function removeOnChange() {}
};